import React, { useCallback } from "react";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import t from "common/i18n";
import appConfig from "appConfig";
import { globalTheme } from "@cld/component-theme";
import { Combobox } from "@cld/combobox";
import { useProducts, usePurchaseInfo } from "../../selectors";
import { today } from "../../utils";

const SectionBox = styled.section`
	border-bottom: 1px solid ${globalTheme.palette.secondary};
	padding: ${globalTheme.spacing.md};
	label {
		font-weight: bold;
		white-space: nowrap;
		display: block;
		padding-bottom: ${globalTheme.spacing.xs};
		font-size: ${globalTheme.font.size.xs};
	}
	.uw-radio-group li .label {
		text-align: left;
	}
`;
const SectionHeader = styled.div`
	display: flex;
	justify-content: space-between;
`;

const FormatLabel = styled.div`
	padding-top: ${globalTheme.spacing.sm};
	color: ${globalTheme.palette.secondary};
`;
const ManagePlanLink = styled.a`
	font-weight: bold;
`;


const generateDescription = (product, selectedAsset) => {
	if (!product?.expirationUtcDate && product?.type !== "creditpack") {
		return null;
	}
	if (!product?.downloadsRemaining && product?.type !== "creditpack") {
		return null;
	}
	const endDate = new Date(product.expirationUtcDate);

	const dayDifference = Math.ceil((endDate - today()) / 1000 / 60 / 60 / 24);
	if (product.downloadsRemaining && product.downloadLimit) {
		return `${product.downloadsRemaining}/${product.downloadLimit} - ${dayDifference} ${t("istock.purchase.days_left")}`;
	}
	else if (product.type === "creditpack" && product.creditsRemaining < selectedAsset.creditPrice) {
		return t("istock.purchase.credits_balance_too_small");
	}
	else if (product.type === "creditpack" && product.creditsRemaining) {
		return `${product.creditsRemaining} ${t("istock.purchase.credits_remaining")}`;
	}
	return null;
};

export default ({ selectProduct, selectedAsset }) => {
	const dispatch = useDispatch();
	const { products, selectedProduct } = useProducts();
	const { isAssetIncludedInProduct } = usePurchaseInfo();

	const description = generateDescription(products.find(item => item.id === selectedProduct?.id), selectedAsset);

	const planChange = useCallback((item) => {
		dispatch(selectProduct(item?.value));
	}, [selectProduct, dispatch]);

	return (<SectionBox>
		<SectionHeader>
			<label>{t("istock.purchase.select_plan")}</label>
			<ManagePlanLink target="_blank" rel="noopener noreferrer" href={appConfig.iStock.managePlanLink}>
				{t("istock.purchase.manage_plans")}
			</ManagePlanLink>
		</SectionHeader>
		<Combobox
			size="md"
			isSearchable={false}
			isClearable={false}
			placeholder={t("istock.select")}
			options={products}
			value={selectedProduct}
			onChange={planChange}
		/>
		{isAssetIncludedInProduct && description && <FormatLabel>
			{description}
		</FormatLabel>}
		{selectedProduct?.exceeded && <FormatLabel>
			{t("istock.purchase.plan_exceeded")}
		</FormatLabel>}
		{selectedProduct && !selectedProduct.exceeded && !isAssetIncludedInProduct && <FormatLabel>
			{t("istock.purchase.media_type_not_included", { mediaType: t(`istock.media_types_singular.${selectedAsset.mediaType}`) } )}
		</FormatLabel>}
	</SectionBox>);
};
